var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grouped-event-grid"},_vm._l((_vm.data),function(group){return _c('Group',{key:group.id,attrs:{"person":group.person,"events":group.events}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }